import { canonicalCellOrder } from '@cards/engine';
import { cardRef, defineGameCard, onResolve } from '../authoring/index.js';
export const GeneralLevyCard = defineGameCard({
    id: 'general_levy',
    gameplay: { type: 'SPELL', cost: 8 },
    presentation: {
        name: 'Всеобщее ополчение',
        description: 'Создайте до трёх Ополченцев 2/2 в случайных свободных ячейках на вашей стороне поля.',
        glyph: {
            colors: ['#10213A', '#6B5F40', '#7C725E', '#B78D5C', '#4E4533'],
            rows: [
                '..............11....',
                '....11.......1221...',
                '...1221..11.133321..',
                '..13332112213333331.',
                '.133333133321444451.',
                '.124441333333144451.',
                '.124441244445144111.',
                '.111441244445111151.',
                '.1211111144111255221',
                '12222512111151222121',
                '12122122225522122151',
                '15155121222212111121',
                '12111151555215122141',
                '1412212111111212211.',
                '.11221412222141151..',
                '..1511112222111111..',
                '..11111151151.......',
                '.......111111.......',
                '....................',
                '....................',
            ],
        },
    },
    role: 'playable',
    dependencies: [cardRef('militia')],
    abilities: [onResolve((ctx) => {
            if (ctx.self === undefined)
                return;
            const side = ctx.q.player(ctx.self.controllerId).side;
            const freeCells = canonicalCellOrder.filter((cellId) => {
                const cell = ctx.q.cell(cellId);
                return cell?.side === side && cell.occupantId === null && !ctx.q.isCellReserved(cellId);
            });
            for (const cellId of ctx.rng.shuffle(freeCells).slice(0, 3)) {
                ctx.ops.tryCreateToken('militia', ctx.self.controllerId, cellId);
            }
        })],
    ui: { mechanics: ['token'] },
});
//# sourceMappingURL=general_levy.js.map